/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardPaymentResultSummaryViewModel } from "../types/CreditCardPaymentResultSummaryViewModel.ts";
import { creditCardPaymentResultTopErrorViewModelSchema } from "./creditCardPaymentResultTopErrorViewModelSchema.ts";

export const creditCardPaymentResultSummaryViewModelSchema = z.object({
  total: z.optional(z.number().int()),
  approvedCount: z.optional(z.number().int()),
  refusedCount: z.optional(z.number().int()),
  approvalRate: z.optional(z.number()),
  topErrors: z
    .array(z.lazy(() => creditCardPaymentResultTopErrorViewModelSchema))
    .nullish(),
}) as unknown as ToZod<CreditCardPaymentResultSummaryViewModel>;
